import type { OnboardingStep } from '../user/user-info';

// User info (and its onboarding steps) comes from the page load, so a first text sent since then is tracked here
let firstTextSent = false;

export const hasSentFirstText = () => firstTextSent;

// The page-load steps, with the first text marked done once one has gone out in this session
export const withSessionProgress = (steps: OnboardingStep[]) => (
  firstTextSent
    ? steps.map((step) => (step.name === 'first_text' ? { ...step, complete: true } : step))
    : steps
);

// Swaps in a fresh copy of the left nav's server-rendered Get Started panel; its counts come from the server
export const recordFirstTextSent = async (subdomain: string | undefined) => {
  if (firstTextSent) return;
  firstTextSent = true;
  const slot = document.getElementById('onboarding-panel-slot');
  if (!slot || !subdomain) return;
  try {
    const response = await fetch(`/accounts/${subdomain}/onboarding_panel`, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    });
    if (response.ok) slot.innerHTML = await response.text();
  } catch {
    // The stale panel stays until the next page load
  }
};

export const resetFirstTextProgress = () => { firstTextSent = false; };
